import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles({
    img1: {
        borderRadius: '5px',
    },
});

export default useStyles;